// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + ({"214":"polyfills-core-js","748":"polyfills-dom"}[chunkId] || chunkId) + ".js";
};